import Papa from "papaparse";

export async function loadProductHuntCSV(path, fetchOptions = {}) {
  const url = path + (path.includes("?") ? "&" : "?") + "t=" + Date.now();
  const res = await fetch(url, fetchOptions);
  if (!res.ok)
    throw new Error(`Failed to load CSV: ${res.status} ${res.statusText}`);
  const text = await res.text();
  const { data } = Papa.parse(text, {
    header: true,
    skipEmptyLines: true,
    transformHeader: (header) => header.trim(),
  });
  return { rows: data.map(normalizeRow) };
}

function normalizeRow(r) {
  const clone = { ...r };

  // Normalize numeric fields
  clone.followers_count = safeNumber(r.followers_count);
  clone.reviews_count = safeNumber(r.reviews_count);
  clone.used_by_count = safeNumber(r.used_by_count);
  clone.rating_average = safeNumber(r.rating_average);
  clone.awards_count = safeNumber(r.awards_count);

  // Keep title
  clone.title = r.title;

  return clone;
}

function safeNumber(v) {
  if (v === null || v === undefined || v === "") return 0;

  const cleaned = String(v).replace(/,/g, "").replace(/\s+/g, "").trim();

  // Handle K for thousands
  if (cleaned.endsWith("K")) {
    const num = parseFloat(cleaned.slice(0, -1));
    return Number.isFinite(num) ? num * 1000 : 0;
  }

  const n = Number(cleaned);
  return Number.isFinite(n) ? n : 0;
}
